import { useTranslation } from "react-i18next";
import { Menu, FolderOpen } from "lucide-react";
import { trackChatModeSwitch } from "@/lib/analytics";
import { OPEN_PAGE_KEY } from "@/constants";
import { FEATURES } from "@/config";

export type AppMode = "chat" | "files" | "gebreken";

interface HeaderProps {
  mode: AppMode;
  onModeChange: (mode: AppMode) => void;
  sidebarOpen: boolean;
  onSidebarToggle: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  mode,
  onModeChange,
  onSidebarToggle,
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-[#333] sticky top-0 z-50 flex h-12 tablet:h-14 items-stretch border-b border-gray-600">
      {/* Menu button */}
      <button
        onClick={onSidebarToggle}
        className="flex items-center justify-center size-12 tablet:size-14 text-white transition-colors border-r border-gray-600 hover:bg-[#1a3a5c]"
        aria-label={t("common:header.projecten")}
      >
        <Menu className="size-5 tablet:size-6" />
      </button>

      {/* Files button */}
      <button
        onClick={() => {
          onModeChange("files");
          sessionStorage.setItem(OPEN_PAGE_KEY, "files");
          trackChatModeSwitch("files");
        }}
        className={`flex items-center justify-center size-12 tablet:size-14 transition-colors border-r border-gray-600 ${
          mode === "files"
            ? "bg-primary text-white"
            : "text-white hover:bg-[#1a3a5c]"
        }`}
        aria-label={t("common:header.files")}
      >
        <FolderOpen className="size-5 tablet:size-6" />
      </button>

      {/* Rapport van Bevindingen tab */}
      <button
        onClick={() => {
          onModeChange("chat");
          sessionStorage.setItem(OPEN_PAGE_KEY, "chat");
          trackChatModeSwitch("chat");
        }}
        className={`flex-1 flex items-center justify-center text-base font-medium transition-colors border-r border-gray-600 ${
          mode === "chat"
            ? "bg-primary text-white hover:bg-[#1a3a5c]"
            : "text-white hover:bg-[#1a3a5c]"
        }`}
      >
        <span className="hidden sm:inline">{t("common:header.PvB")}</span>
        <span className="sm:hidden">{t("common:header.PvBShort")}</span>
      </button>

      {/* Gebreken tab */}
      <button
        disabled={!FEATURES.gebrekenPageEnabled}
        onClick={() => {
          if (!FEATURES.gebrekenPageEnabled) return;
          onModeChange("gebreken");
          sessionStorage.setItem(OPEN_PAGE_KEY, "gebreken");
          trackChatModeSwitch("gebreken");
        }}
        className={`flex-1 flex items-center justify-center text-base font-medium transition-colors ${
          !FEATURES.gebrekenPageEnabled
            ? "text-white/50 cursor-not-allowed"
            : mode === "gebreken"
              ? "bg-primary text-white hover:bg-[#1a3a5c]"
              : "text-white hover:bg-[#1a3a5c]"
        }`}
        aria-label={t("common:header.gebreken")}
      >
        <span className="hidden sm:inline">{t("common:header.Gebreken")}</span>
        <span className="sm:hidden">{t("common:header.GebrekenShort")}</span>
      </button>

    </div>
  );
};
